














import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { Order } from '@/models/order';
import { OrderApi } from '@/api/order-api';
import { OrderHistory } from '@/models/order-history';
import { Forbidden } from '@/models/forbidden-error';
import orderDetails from '@/components/order-details.vue';
import { NotFound } from '@/models/not-found-error';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const orderApi = new OrderApi();
const userModule = namespace('user');

@Component({
    components: {
        orderDetails,
    },
})
export default class ViewOrder extends Vue {
    public isLoading: boolean = true;
    public order: Order | null = null;
    public history: Array<OrderHistory> = new Array<OrderHistory>();
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.load();
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.load();
    }
    public async handleOrderReceived(id: string): Promise<void> {
        await orderApi.receiveAsync(id);
        await this.load();
    }
    public async handleOrderDelivered(id: string): Promise<void> {
        await orderApi.deliverAsync(id);
        await this.load();
    }
    public async load(): Promise<void> {
        try {
            const order = await orderApi.fetchByIdAsync(this.$route.params.id);
            const history = await orderApi.fetchHistoryByIdAsync(this.$route.params.id);
            this.order = order;
            this.history = history;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                this.$router.push({ name: 'not-found' });
            }
        }
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.load();
        this.isLoading = false;
    }
}
